import { Tab, Tabs, Typography } from "@material-ui/core";
import { Bagde } from "components/Card";
import { theme } from "config/theme";
import TaskBagde from "domains/Tasks/TaskBadge";
import React from "react";
import "styled-components/macro";
import { TabStyles } from "./styles";

export interface TabProps {
  libelle: string;
  id: string;
  count?: number;
}

export interface TabsPros {
  onChange?: (tabElement: TabProps) => void;
  tabs: TabProps[];
  defaultValue?: number;
  withBadge?: boolean;
  isTask?: boolean;
}

export function NavSwitcher({ onChange, tabs, isTask, defaultValue = 0, withBadge }: TabsPros) {
  const [value, setValue] = React.useState(defaultValue);
  const styles = TabStyles();

  React.useEffect(() => {
    if (defaultValue !== 0) {
      setValue(defaultValue);
    }
  }, [defaultValue]);
  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setValue(newValue);
    onChange(tabs[newValue]);
  };
  return (
    <Tabs
      value={value}
      onChange={handleChange}
      variant="fullWidth"
      indicatorColor="secondary"
      aria-label="icon tabs example"
      css={`
        .MuiTab-wrapper {
          border-radius: 25px;
          flex-direction: row-reverse;
          text-transform: capitalize;
          background-color: rgba(57, 158, 191, 0.08);
          width: 155px !important;
          transition: color 0.5s;
          justify-content: space-evenly;
          margin-right: auto;
          margin-left: -13px;
          padding-top: 6px;
        }
        .MuiTab-fullWidth {
          z-index: 1;
        }
        .MuiTabs-indicator {
          height: 2em;
          border-radius: 25px;
          bottom: 20.5px;
          background: #399ebf;
          width: 155px !important;
          ${theme.breakpoints.down("xs")} {
            width: 110px !important;
          }
        }
        .Mui-selected {
          color: #ffffff;
        }
      `}
    >
      {tabs.map((tab, index) => (
        <Tab
          key={index}
          css={`
            .Mui-selected {
              color: #fff;
            }
          `}
          icon={
            <div
              css={`
                margin-top: 3px;
                margin-left: 12px;
                margin-bottom: 0px !important;
                ${theme.breakpoints.down("xs")} {
                  margin-left: -103px !important;
                  margin-right: -19px;
                }
              `}
            >
              {withBadge && !isTask ? (
                <Bagde
                  value={tab.count.toString()}
                  fontSize={7}
                  height={14}
                  width={14}
                  variante={value === index ? "outlined" : "contained"}
                  key={index}
                />
              ) : (
                isTask && <TaskBagde value={tab.count.toString()} key={index} tab={value} />
              )}
            </div>
          }
          label={
            <Typography className={styles.label} display="inline">
              {tab.libelle}
            </Typography>
          }
        />
      ))}
    </Tabs>
  );
}

export default NavSwitcher;
